import React, { Component } from "react";
import axios from "axios";
import cookie from "react-cookies";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import $ from "jquery";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  isEmpty,
  isSingleSelect,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
var module = "product-group";
var moduleName = "Product Group";
var modulePath = "/clientpanel/catalog-group";
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = "";
    if (this.props.match.path === "/clientpanel/catalog-group/edit/:EditID") {
      editID = this.props.match.params.EditID;
    }
    var allowOutlet = cookie.load("clientAllowOutlet") ?? "";
    this.state = {
      editID: editID,
      pageloading: false,
      postdata: {
        groupName: "",
        groupExitProducts:[],
        groupStatus: "",
      },
      loading: true,
      formpost: [],
      companyDetail: [],
      productList: [],
      allowOutlet: allowOutlet,
      group_products: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    if (this.state.editID !== "") {
      var params = {
        params:'' ,
        url: `${apiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.props.getDetailData(params);

      this.setState({ pageloading: true });
    }else {
      this.loadProducts();
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost !== nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          var history = this.props.history;
          setTimeout(function () {
            history.push(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var groupStatus = result.groupStatus === "A" ? "Active" : "In Active";
          var status =
            result.groupStatus !== "" && result.groupStatus !== null
              ? {
                  label: groupStatus,
                  value: result.groupStatus,
                }
              : "";
          var clientupdatedata = {
            groupName: result.groupName,
            groupExitProducts:result.groupProductID,
            groupStatus: status,
          };
          this.setState(
            {
              postdata: clientupdatedata,
              pageloading: false,
            },
            function () {
              this.loadProducts();
            }
          );
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }

  loadProducts() {
    var urlShringTxt = apiUrl + "products/productWithCategory" ;
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        let result = [];
        if(this.state.postdata.groupExitProducts.length>0) {
          result = res.data.result.map(category => {
            let allSubCategoriesChecked = true;
        
            const updatedSubCategories = category.subCategory.map(sub => {
                let allProductsChecked = true;
        
                const updatedProducts = sub.products.map(product => {
                    const isChecked = this.state.postdata.groupExitProducts.includes(product._id);
                    if (!isChecked) allProductsChecked = false;
                    return { ...product, checked: isChecked };
                });
        
                // Set `checked: true` for subCategory if all its products are checked
                const subChecked = updatedProducts.length > 0 && allProductsChecked;
                if (!subChecked) allSubCategoriesChecked = false;
        
                return { ...sub, products: updatedProducts, checked: subChecked };
            });
        
            // Set `checked: true` for category if all its subcategories are checked
            const categoryChecked = updatedSubCategories.length > 0 && allSubCategoriesChecked;
        
            return { ...category, subCategory: updatedSubCategories, checked: categoryChecked };
        });
          
         /*  res.data.result.map(category => ({
            ...category,
            subCategory: category.subCategory.map(sub => ({
                ...sub,
                products: sub.products.map(product => ({
                    ...product,
                    checked: this.state.postdata.groupExitProducts.includes(product._id) // Add checked: true if found
                }))
            }))
          })); */
        }else {
          result = res.data.result;
        }

        this.setState({ productList: result });
      }
    }).catch((e) => {
      console.log(e)
    });

  }
  sateValChange = (field, value) => {};

  selectProduct = (catindex, subcateIndex, updindex, updType, event) => {
    var productList = this.state.productList;
    var checkedStatus = event.target.checked;
    var finaProList = [];
    productList.map((item, index) => {
      var subcate = [];
      var catChecked = item?.checked ?? false;

      if (catindex === index && updType === "category") {
        catChecked = checkedStatus;
      }
      var totalSubCatCheck = 0;
      if (item.subCategory.length > 0) {
        item.subCategory.map((item1, index1) => {
          var subcatCheckd = item1?.checked ?? false;
          if (catindex === index && subcateIndex === index1 && updType === "subcategory") {
            subcatCheckd = checkedStatus;
          }
          var producs = [];
          var totalProCheck = 0;
          if (item1.products.length > 0) {
            item1.products.map((item2, index2) => {
              var proChecked = item2.checked;
              if (
                catindex === index &&
                subcateIndex === index1 &&
                updindex === index2 &&
                updType === "product"
              ) {
                proChecked = checkedStatus;
              }
              if (
                catindex === index &&
                subcateIndex === index1 &&
                (updType === "category" || updType === "subcategory")
              ) {
                proChecked = checkedStatus;
              }
              if (proChecked === true) {
                totalProCheck++;
              }

              producs.push({
                value: item2.value,
                label: item2.label,
                checked: proChecked,
              });
              return '';
            });
          }
          if (totalProCheck === item1.products.length && item1.products.length>0) {
            subcatCheckd = true;
          }
          if (subcatCheckd === true) {
            totalSubCatCheck++;
          }
          subcate.push({
            value: item1.value,
            label: item1.label,
            checked: subcatCheckd,
            products: producs,
          });
          return '';
        });
      }
      if (totalSubCatCheck === item.subCategory.length) {
        catChecked++;
      }
      finaProList.push({
        value: item.value,
        label: item.label,
        checked: catChecked,
        subCategory: subcate,
      });
      return '';
    });
    this.setState({ productList: finaProList });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;
    var groupProductID = [];
    if (this.state.productList.length > 0) {
      this.state.productList.map((cat) => {
        if (cat.subCategory.length > 0) {
          cat.subCategory.map((subcat) => {
            if (subcat.products.length > 0) {
              subcat.products.map((pro) => {
                if (pro?.checked === true) {
                  groupProductID.push(pro.value);
                }
                return '';
              });
            }
            return "";
          });
          return '';
        }
        return '';
      });
    }
    var postObject = {
      groupName: postData.groupName,
      groupProductID: groupProductID.length > 0 ? groupProductID.join(",") : "",
      groupStatus: postData.groupStatus?.value ?? "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = 'update';
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"catalog-group"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"}{" "}
                      {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  productList={this.state.productList}
                  allowOutlet={this.state.allowOutlet}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  selectProduct={this.selectProduct}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { groupName, groupStatus } = props.fields;

  return {
    fields: ["groupName", "groupStatus"],

    validations: {
      groupName: [[isEmpty, groupName]],
      groupStatus: [[isSingleSelect, groupStatus]],
    },
  };
}

class PostForm extends Component {

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgName,
      errMsgStatus = "";
    if ($validation.groupName.error.reason !== undefined) {
      errMsgName = $validation.groupName.show && (
        <span className="error">{$validation.groupName.error.reason}</span>
      );
    }

    if ($validation.groupStatus.error.reason !== undefined) {
      errMsgStatus = $validation.groupStatus.show && (
        <span className="error">{$validation.groupStatus.error.reason}</span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgName !== "" &&
                  errMsgName !== false &&
                  errMsgName !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="groupName"
                value={fields.groupName}
                {...$field("groupName", (e) =>
                  onChange("groupName", e.target.value)
                )}
              />
              <label htmlFor="groupName">
                Group Name <span className="error">*</span>
              </label>
              {errMsgName}
            </div>
          </div>
          {this.props.productList.length > 0 && (
            <div className="col-md-12 col-12">
              <div className="mb-md-0 mb-4">
                <div className="jstree jstree-5 jstree-default jstree-checkbox-selection">
                  <ul className="jstree-container-ul jstree-children jstree-wholerow-ul jstree-no-dots">
                    {this.props.productList.map((item, index) => {
                      const hasProducts = item.subCategory.some(sub => sub.products.length > 0);
                      if(item.subCategory.length>0 && hasProducts===true) {
                        return (
                          <li
                            role="none"
                            className="jstree-node  jstree-open"
                            key={index}
                          >
                            <div unselectable="on" className="jstree-wholerow">
                              &nbsp;
                            </div>
                            <i className="jstree-icon jstree-ocl"></i>
                            <a
                              className={
                                item.checked === true
                                  ? "jstree-anchor jstree-clicked"
                                  : "jstree-anchor"
                              }
                              href="/"
                            >
                              <div className="form-check form-check-inline">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  onClick={this.props.selectProduct.bind(
                                    this,
                                    index,
                                    "",
                                    "",
                                    "category"
                                  )}
                                  checked={item?.checked ?? false}
                                />
                                <i className="jstree-icon jstree-themeicon mdi mdi-folder-outline jstree-themeicon-custom"></i>
                                {item.label}
                              </div>
                            </a>
                            {item.subCategory.length > 0 && hasProducts===true && (
                              <ul role="group" className="jstree-children">
                                {item.subCategory.map((subcateItem, subcateIndex) => {
                                      if(subcateItem.products.length > 0) {
                                    return (
                                      <li
                                        role="none"
                                        className="jstree-node  jstree-open"
                                        key={subcateIndex}
                                      >
                                        <div
                                          unselectable="on"
                                          className="jstree-wholerow"
                                        >
                                          &nbsp;
                                        </div>
                                        <i className="jstree-icon jstree-ocl"></i>
                                        <a
                                          className={
                                            subcateItem?.checked === true
                                              ? "jstree-anchor jstree-clicked"
                                              : "jstree-anchor"
                                          }
                                          href="/"
                                        >
                                          <div className="form-check form-check-inline">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              onClick={this.props.selectProduct.bind(
                                                this,
                                                index,
                                                subcateIndex,
                                                "",
                                                "subcategory"
                                              )}
                                              checked={subcateItem?.checked}
                                            />
                                            <i className="jstree-icon jstree-themeicon mdi mdi-folder-outline jstree-themeicon-custom"></i>
                                            {subcateItem.label}
                                          </div>
                                        </a>
                                        {subcateItem.products.length > 0 && (
                                          <ul
                                            role="group"
                                            className="jstree-children"
                                          >
                                            {subcateItem.products.map((proItem, proIndex) => {
                                                return (
                                                  <li
                                                    role="none"
                                                    className="jstree-node  jstree-leaf"
                                                    key={proIndex}
                                                  >
                                                    <div
                                                      unselectable="on"
                                                      className="jstree-wholerow"
                                                    >
                                                      &nbsp;
                                                    </div>
                                                    <i className="jstree-icon jstree-ocl"></i>
                                                    <a
                                                      className={
                                                        proItem.checked === true
                                                          ? "jstree-anchor jstree-clicked"
                                                          : "jstree-anchor"
                                                      }
                                                      href="/"
                                                    >
                                                      <div className="form-check form-check-inline">
                                                        <input
                                                          className="form-check-input"
                                                          type="checkbox"
                                                          onClick={this.props.selectProduct.bind(
                                                            this,
                                                            index,
                                                            subcateIndex,
                                                            proIndex,
                                                            "product"
                                                          )}
                                                          checked={proItem?.checked}
                                                        />
                                                        <i className="jstree-icon jstree-themeicon mdi mdi-alpha-p-circle-outline jstree-themeicon-custom"></i>
                                                        {proItem.label}
                                                      </div>
                                                    </a>
                                                  </li>
                                                );
                                              }
                                            )}
                                          </ul>
                                        )}
                                      </li>
                                    );
                                  }else {
                                    return "";
                                  }
                                  }
                                )}
                              </ul>
                            )}
                          </li>
                        );
                      } else {
                        return "";
                      }
                    })}
                  </ul>
                </div>
              </div>
            </div>
          )}
          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box mb-4">
              <Select
                value={fields.groupStatus}
                onChange={this.handleSelectChange.bind(this, "groupStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>
          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
